import { groupFiltersByFilterGroup } from "@/data/filters/config";
import { Configuration, QueryFilter } from "@/types/campaign";

// Returns a list of all filter groups from a list of configurations.
export function getFilterGroupsFromConfigurations(
  configurations: Configuration[],
) {
  const groupsByquality = new Map<
    string,
    { values: Record<number, QueryFilter | null> }
  >();

  for (const configuration of configurations) {
    const groupedFilters = groupFiltersByFilterGroup(
      configuration.query.filters,
    );
    for (const { filterGroup } of groupedFilters) {
      const group = groupsByquality.get(filterGroup.id);
      if (!group) {
        groupsByquality.set(filterGroup.id, {
          values: {},
        });
      }
    }
  }

  return groupsByquality;
}

export function getCampaignPriority(configurations: Configuration[]) {
  if (configurations.length === 0) {
    return {
      descendingOrder: false,
      orderBy: null,
    };
  }

  return {
    descendingOrder: configurations[0].query.descendingOrder,
    orderBy: configurations[0].query.orderBy,
  };
}
